import DomainCommon from './common';


const VipService = {
    listTrialVips: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/sales/vip/trialVips`,
                resolve, reject
            });
        });
    },
    list: (params) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip?${DomainCommon.buildQueryString(params)}`,
                resolve, reject
            });
        });
    },
    findById: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}`,
                resolve, reject
            });
        });
    },
    findByUserId: (userId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/user/${userId}`,
                resolve, reject
            })
        })
    },
    findTrialVipById: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/sales/vip/${vipId}`,
                resolve, reject
            });
        });
    },
    addTrialVip: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/sales/vip/generateTrialVip`,
                resolve, reject
            });
        });
    },
    addVip: (vip) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/register/vip`,
                jsonBody: vip,
                resolve, reject
            });
        });
    },
    updateTrialVip: (vip) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/sales/vip/${vip.id}`,
                jsonBody: vip,
                resolve, reject
            });
        });
    },
    updateVip: (vip) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vip.id}`,
                jsonBody: vip,
                resolve, reject
            });
        });
    },
    changePassword: ({vipId, password}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/changePassword`,
                jsonBody: {password},
                resolve, reject
            });
        });
    },
    avatarGetUrl: ({base64Image}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/image/url`,
                jsonBody: {base64_src: base64Image},
                resolve, reject
            });
        });
    },
    enable: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/enable`,
                resolve, reject
            });
        });
    },
    notifiedVip: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/notified`,
                resolve, reject
            });
        });
    },
    validateVipEmail: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/validate`,
                resolve, reject
            });
        });
    },
    /*sendSurvey2020: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/sendSurvey2020`,
                resolve, reject
            });
        });
    },*/
    sendCustomMail: ({ vipId, subject, content }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/sendCustomMail`,
                jsonBody: { subject, content },
                resolve, reject,
            })
        })
    },
    autoVerifyOcc: ({ vipId, id, areaCode }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/occ`,
                jsonBody: { id, areaCode },
                resolve, reject,
            });
        });
    },
    updateOccVerifyStatus: ({ vipId, id, areaCode, isVerified }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPatch({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/occ`,
                jsonBody: { id, areaCode, isVerified },
                resolve, reject,
            });
        });
    },
    reSendValidateEMail: ({email}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/user/reSendValidateEMail`,
                jsonBody: {email},
                resolve, reject
            });
        });
    },
    disableTrialVip: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/sales/vip/${vipId}/disable`,
                resolve, reject
            });
        });
    },
    disableVip: (vipId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/disable`,
                resolve, reject
            });
        });
    },
    vipChoosePlan: ({vipId, pricePlan}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/choosePlan`,
                jsonBody: {pricePlan},
                resolve, reject
            });
        });
    },
    vipJoinClub: ({vipId, missionTypeId, period_in_milliseconds, points, groupType}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/joinClub`,
                jsonBody: {groupType},
                resolve, reject
            });
        });
    },
    plusUseRecord: ({vipId, missionTypeId, period_in_milliseconds, points}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/plusUseRecord`,
                jsonBody: {missionTypeId, period_in_milliseconds, points},
                resolve, reject
            });
        });
    },
    companyVipJoinClub: ({vipId, missionTypeId, period_in_milliseconds, points}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/companyJoinClub`,
                jsonBody: {missionTypeId, period_in_milliseconds, points},
                resolve, reject
            });
        });
    },
    removePlan: vipId => new Promise((resolve, reject) => DomainCommon.fetchPost({
        url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/vip/${vipId}/removePlan`,
        resolve, reject,
    })),
};

export default VipService;



// WEBPACK FOOTER //
// ./src/service/vip.js